import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTodoEditComponent } from '@fi-app/fi-onboarding/fi-todo/fi-todo-edit/fi-todo-edit.component';
import { FormsModule } from '@angular/forms';
import { SideListModule } from '@fi-app/utilities/side-list/side-list.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { FiAccessRightFiltersModule } from '@fi-shared/access-right-filters';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiTwoColumnsContainerModule } from '@fi-app/shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiNameDescriptionInputModule } from '@fi-app/shared/name-description-input/name-description-input.module';
import { FiTranslationRadioGroupModule } from '@fi-shared/fi-translation-radio-group/fi-translation-radio-group.module';
import { MatCardModule } from '@angular/material/card';
import { FiTodoListStoreService } from './fi-todo-list-editor-store.service';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiSectionCardModule } from '@fi-shared/fi-section-card/fi-section-card.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiTodoSectionsEditComponent } from './fi-todo-sections-edit/fi-todo-sections-edit.component';
import { FiSectionsDndEditorModule } from '@fi-shared/fi-sections-dnd-editor/fi-sections-dnd-editor.module';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiThreeColumnsContainerModule } from '@fi-app/shared/fi-three-columns-container/fi-three-columns-container.module';
import { FiTodoItemComponent } from './fi-todo-sections-edit/fi-todo-item/fi-todo-item.component';
import { FiTodoItemEditComponent } from './fi-todo-item-edit/fi-todo-item-edit.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FiTodoEditorGuideCardComponent } from './fi-todo-editor-guide-card/fi-todo-editor-guide-card.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FiProgressTimelineModule } from '@fi-app/shared/fi-progress-timeline/fi-progress-timeline.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SideListModule,
        FiAppTextSharedModule,
        FiSimpleContenteditableModule,
        FiAccessRightFiltersModule,
        MatRadioButton,
        MatRadioGroup,
        MatCheckbox,
        MatIconModule,
        MatButtonModule,
        FiTwoColumnsContainerModule,
        FiNameDescriptionInputModule,
        FiTranslationRadioGroupModule,
        MatCardModule,
        FiValidatingFormModule,
        FiSectionCardModule,
        FiTooltipModule,
        FiSectionsDndEditorModule,
        FiIconTooltipButtonModule,
        FiThreeColumnsContainerModule,
        MatTabsModule,
        MatExpansionModule,
        FiProgressTimelineModule,
    ],
    declarations: [
        FiTodoEditComponent,
        FiTodoSectionsEditComponent,
        FiTodoItemComponent,
        FiTodoItemEditComponent,
        FiTodoEditorGuideCardComponent,
    ],
    providers: [FiTodoListStoreService],
})
export class FiTodoEditModule {}
